import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

// Async thunk to get state compliances
export const fetchStateCompliances = createAsyncThunk(
  "compliance/fetchStateCompliances",
  async ({ states, token }, thunkAPI) => {
    console.log("states api", states);
    try {
      const res = await axios.get(
        `${BACKEND_URL}/states/${states}/compliances`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      console.log("response", res);
      return res.data.data; // return only the data object
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getEditDocument = createAsyncThunk(
  "compliance/getEditDocument",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/users/compliances/documents`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      console.log("response", res);
      return res.data; // return only the data object
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const saveStateCompliance = createAsyncThunk(
  "compliance/saveStateCompliance",
  async ({ token, formData }, thunkAPI) => {
    try {

      const res = await axios.post(
        // `${BACKEND_URL}/states/compliances`,
        `${BACKEND_URL}/users/compliances/documents`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // ❗ DO NOT set Content-Type manually
          },
        }
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "API call failed"
      );
    }
  }
);

const complianceSlice = createSlice({
  name: "compliance",
  initialState: {
    data: null,
    loading: false,
    editDocument: [],
    error: null,
    saving: false,
    saveError: null,
    saveResponse: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchStateCompliances cases
      .addCase(fetchStateCompliances.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStateCompliances.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStateCompliances.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // saveStateCompliance cases
      .addCase(saveStateCompliance.pending, (state) => {
        state.saving = true;
        state.saveError = null;
        state.saveResponse = null;
      })
      .addCase(saveStateCompliance.fulfilled, (state, action) => {
        state.saving = false;
        state.saveResponse = action.payload;
      })
      .addCase(saveStateCompliance.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload;
      })
      .addCase(getEditDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEditDocument.fulfilled, (state, action) => {
        state.loading = false;

        const payload = action.payload || {};
        console.log("payload", payload);

        // 1️⃣ Education Level
        const education_level =
          payload.answer?.find(a => a.question_key === "education_level")
            ?.answer_value || "";

        const background = {};
        Object.entries(payload.background_check || {}).forEach(
          ([key, value]) => {
            background[key] = Boolean(value); // 1 → true, 0 → false
          }
        );

        // 3️⃣ Role checks → split teacher / support_staff
        const teacher = {};
        const support_staff = {};

        Object.entries(payload.role_checks || {}).forEach(([key, value]) => {
          if (key.startsWith("teacher_")) {
            teacher[key.replace("teacher_", "")] = Boolean(value);
          }

          if (key.startsWith("support_staff_")) {
            support_staff[key.replace("support_staff_", "")] = Boolean(value);
          }
        });

        // 3️⃣ Documents → flatten
        const documents = {};
        payload.documents?.forEach(doc => {
          Object.keys(doc).forEach(key => {
            if (key.startsWith("documents.")) {
              const docKey = key.replace("documents.", "");
              documents[docKey] = {
                fileUrl: doc[key].file,
                expiration_date: doc[key].expiration_date,
                is_approve: doc[key].is_approve
              };
            }
          });
        });

        let fingerprint = null;
        if (payload.fingerprint && payload.fingerprint.length > 0) {
          const fpData = payload.fingerprint[0]["documents.fingerprint"];
          fingerprint = {
            file: null,           // user can upload a new file
            fileUrl: fpData.file, // existing file
            expiration_date: fpData.expiration_date,
            is_approve: fpData.is_approve,
            isUpdated: false,
          };
        }

        state.editDocument = {
          education_level,
          background,
          teacher,
          support_staff,
          documents,
          fingerprint
        };
      })
      .addCase(getEditDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },

});

export default complianceSlice.reducer;
